export default "__VITE_ASSET__DF$xjzjD__"